import React from "react"
import {FieldGraphTickLabelViewProps} from "../../../../render/graph-tick-label"
import Field_GraphTickLabelView from "../../../../proto/render/graph-tick-label"

const BOX_SHOW_THRESHOLD = 50

const debug = false
// const debug = "FieldTaskStatus_GraphTickLabelView"

export default function FieldTaskStatus_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)
    const status = gd.session.statuses.get(value)

    debug && console.log(debug, 'render', status, props)

    let showBox = props.params.availableWidth <= BOX_SHOW_THRESHOLD

    let content
    if (showBox) {
        content = <div className={Classes("icon ui5-color-box gd-scbg-{0}".f(status.color))}/>
    } else {
        const statusClasses = Classes("ui5-status-list txt-truncate", "status-c{0}".f(status.color))
        content = <div className={statusClasses}>{status.name}</div>
    }

    return (
        <Field_GraphTickLabelView {...props} hintName={status.name}>
            {content}
        </Field_GraphTickLabelView>
    )
}